import { useRecoilValue } from "recoil"
import { token } from "schemas"

export default function ReturnParams({ setLoad }) {
    const tokenData = useRecoilValue(token)

    function getParams(method, obj, upload) {
        let headerss = {
            'Authorization': `Bearer ${sessionStorage.getItem('token') ?? tokenData}`,
            ...(upload ? {} : { 'Content-Type': 'application/json' }),
            "Accept": "application/json",
        }

        setLoad(true)
        let params = {}

        if (method !== 'get') {
            params = {
                method: method,
                headers: headerss,
                body: upload ? obj : JSON.stringify(obj)
            }
        } else {
            params = {
                method: method,
                headers: headerss,
            }
        }

        return params
    }

    return { getParams }
}